import React, { lazy, PropsWithChildren, Suspense, useMemo } from "react";
import { isCorpTenant, isVesperTenant } from "@capone/common";
import { config } from "../../api/config";

// TravelWalletSelection renders b2bportal's CreditActivityDialog, which needs
// the tenant's I18nProvider/StyleContextProvider in its ancestor tree. This
// module mounts as its own React root (no ancestor host providers), so mount
// the tenant Portal once, high in the tree (see App.tsx) — same pattern as
// customer-profile-module. Portal owns its own router/store, so it must be
// mounted once for the module's lifetime, not scoped to a single route.
//
// LegacyPremierCollectionBook/LegacyPremierCollectionVRBook (b2b-base) render
// this App directly inside the host's own tree instead, already nested under
// BaseProviders' CaponePortal/CorporatePortal — mounting a second Portal
// there would double up the store/router/i18next, so those callers pass
// `skip` to render children as-is.
export const PortalComponentProvider: React.FC<
  PropsWithChildren<{ skip?: boolean }>
> = ({ skip, children }) => {
  const PortalComponent = useMemo(() => {
    if (skip) {
      return null;
    }
    if (isCorpTenant(config.TENANT)) {
      return lazy(
        () =>
          import(
            "../../../../../cap1-application/b2b-base/src/components/Core/CorporatePortal"
          )
      );
    }
    if (isVesperTenant(config.TENANT)) {
      return lazy(
        () =>
          import(
            "../../../../../cap1-application/b2b-base/src/components/Core/VesperPortal"
          )
      );
    }
    return lazy(
      () =>
        import(
          "../../../../../cap1-application/b2b-base/src/components/Core/Portal"
        )
    );
  }, [skip]);

  if (PortalComponent == null) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback="loading">
      <PortalComponent>{children}</PortalComponent>
    </Suspense>
  );
};

